import { useQuery, UseQueryResult } from 'react-query';
import { ApiException } from '../interface/ApiException';
import { ApiError } from '../interface/ApiError';
import { OperatorDataDTO } from '../interface/apiModels';
import { restClient } from '../../../App';
import { OperatorTenant } from './model';

export const useOperatorData = (): UseQueryResult<OperatorTenant[], ApiException<ApiError>> => {
  return useQuery('operatorData', fetchOperatorData, {
    staleTime: 60 * 60 * 1000,
  });
};

const fetchOperatorData = async (): Promise<OperatorTenant[]> => {
  return restClient.getOperatorData().then(convertOperatorData);
};

const convertOperatorData = (operatorDataDTO: OperatorDataDTO): OperatorTenant[] => {
  return operatorDataDTO.tenantData.map((tenantData) => {
    return {
      id: tenantData.tenantName,
      totalChallenges: tenantData.totalChallenges,
      totalResults: tenantData.totalResults,
      latestChallenge: tenantData.latestChallenge ? new Date(tenantData.latestChallenge) : undefined,
      latestResult: tenantData.latestResult ? new Date(tenantData.latestResult) : undefined,
      tenantCreationDate: new Date(tenantData.tenantCreationDate),
      tenantName: tenantData.tenantName,
      challengesInLastThirtyDays: tenantData.challengesInLastThirtyDays,
      resultsInLastThirtyDays: tenantData.resultsInLastThirtyDays,
    };
  });
};
